import { baseApi } from "../redux/baseAPI";

export const restrictedIpApi = baseApi.injectEndpoints({
  tagTypes: ["RestrictedIps"],
  endpoints: (builder) => ({
    getRestrictedIps: builder.query({
      query: (data) => {
        return {
          url: `/nurse_location_ips/index.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["RestrictedIps"],
    }),
    addRestrictedIp: builder.mutation({
      query: (body) => ({
        url: `/nurse_location_ips/add.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ["RestrictedIps"],
    }),
    deleteRestrictedIp: builder.mutation({
      query: (body) => ({
        url: `/nurse_location_ips/delete.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ["RestrictedIps"],
    }),
  }),
});

export const {
  useGetRestrictedIpsQuery,
  useAddRestrictedIpMutation,
  useDeleteRestrictedIpMutation,
} = restrictedIpApi;
